import React, { useState, useEffect } from "react";
import "./about.css";

const About = () => {
    const [content, setContent] = useState({
        about_title: "About Me",
        about_paragraphs: [
            "Unity Gameplay & Systems Engineer with 4+ years of experience shipping mobile and WebGL titles including hypercasual, casino, and strategy games. I specialize in gameplay systems, AI, multiplayer architecture, and production pipelines.",
            "My core expertise includes: Game loops & core mechanics, state machines, turn-based systems, AI & rule-based logic, Android/iOS/WebGL publishing, rapid prototyping, monetization systems (ads & transactional), and performance optimization.",
            "I've led teams, mentored junior developers, and successfully shipped 5+ titles to production. I'm passionate about modular architecture, clean code, and creating scalable systems that enable rapid iteration and cross-team collaboration."
        ]
    });

    useEffect(() => {
        fetch("/content.json")
            .then(res => res.json())
            .then(data => {
                setContent({
                    about_title: data.about_title || content.about_title,
                    about_paragraphs: data.about_paragraphs || content.about_paragraphs
                });
            })
            .catch(err => console.log("Using default about content"));
    }, []);

    return (
        <section id="about" className="py-20 md:py-28 transition-colors duration-300">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
                <div className="space-y-8">
                    {/* Header */}
                    <div className="space-y-3 border-b border-gray-300 dark:border-gray-700 pb-8">
                        <h2 className="text-4xl md:text-5xl font-bold">{content.about_title}</h2>
                        <p className="text-lg" style={{color: 'rgb(var(--accent-color))'}}>
                            Professional Game Developer & Systems Architect
                        </p>
                    </div>

                    {/* Content */}
                    <div className="space-y-6 max-w-4xl">
                        {content.about_paragraphs && content.about_paragraphs.map((para, idx) => (
                            <p key={idx} className="text-base md:text-lg leading-relaxed">
                                {para}
                            </p>
                        ))}
                    </div>

                    {/* CTA Buttons */}
                    <div className="flex flex-wrap gap-4 pt-8">
                        <a 
                            href="#experience"
                            className="px-6 py-3 rounded-lg font-medium transition-all duration-300 border"
                            style={{
                                borderColor: 'rgb(var(--accent-color))',
                                color: 'rgb(var(--accent-color))'
                            }}
                        >
                            View Experience
                        </a>
                        <a 
                            href="#contact"
                            className="px-6 py-3 rounded-lg text-white font-medium transition-colors duration-300"
                            style={{background: 'rgb(var(--accent-color))'}}
                        >
                            Get in Touch
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
